import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { UserRegionalService } from '../../user/user-regional.service';

const API_URL = environment.apiUrl;

@Injectable()
export class AuthRegionalService {
  constructor(
    private http: HttpClient,
    private userRegionalService: UserRegionalService
  ) {}

  login(email: string, password: string): Observable<any> {
    const loginData = { email, password };

    return this.http
      .post(API_URL + '/auth-regional-login-check', loginData, { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userRegionalService.setToken(authToken);
        }),
        map((res: any) => res.body)
      );
  }

  logout(): void {
    this.userRegionalService.logout();
  }

  forgotPassword(body: any): Observable<any> {
    return this.http.post(API_URL + '/regional-resetting-password-request', body);
  }

  validateResetToken(token: string): Observable<any> {
    return this.http.get(
      API_URL + '/regional-resetting-password-verify-token/' + token,
      {}
    );
  }

  resetPassword(body: any): Observable<any> {
    return this.http.post(API_URL + '/regional-resetting-password-reset', body);
  }

  changePassword(body: any, userId: number): Observable<any> {
    return this.http
      .put(API_URL + '/regionals/' + userId + '/change-password', body, {
        observe: 'response',
      })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userRegionalService.setToken(authToken);
        })
      );
  }

  refreshToken(): Observable<any> {
    return this.http
      .get(API_URL + '/regional-refresh-token', { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userRegionalService.setToken(authToken);
        })
      );
  }
}
